"use client";

import Tooltip from "@mui/material/Tooltip";
import { ComponentProps } from "react";
import { twMerge } from "tailwind-merge";

import { useUpdateQuery } from "@/hooks/use-update-query";

type Props = ComponentProps<"button"> & {
  id: string;
  isActive: boolean;
  description: string;
};

export const TabButton = ({ id, isActive, description, ...props }: Props) => {
  const { updateQuery } = useUpdateQuery();
  return (
    <Tooltip
      enterTouchDelay={0}
      arrow={true}
      title={description}
      placement="top"
      slotProps={{
        tooltip: { className: "bg-zinc-900 text-white" },
        arrow: { className: "text-zinc-900" },
      }}
    >
      <button
        {...props}
        className={twMerge(
          isActive
            ? "border-sky-600 text-sky-700"
            : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700",
          "border-b-2 px-1 py-4 text-center text-base font-medium",
          props.className
        )}
        onClick={() => {
          updateQuery({ name: "factor", value: id });
        }}
      >
        {props.children}
      </button>
    </Tooltip>
  );
};
